module.exports = __webpack_public_path__ + "img/undraw_chef.f2b044bd.svg";